<template>
  <Button color="primary" :label="lc.label" :to="addDomainPath"/>
</template>

<script>
import { Button } from '@locaweb/design-system-vue'

export default {
  name: 'AddDomainButton',
  components: {
    Button
  },
  computed: {
    lc () {
      return this.$lc('domains.manageDomain.addDomainButton')
    },
    addDomainPath () {
      return { name: 'addDomain' }
    }
  }
}
</script>
